import styled from "styled-components";
import { Loading, Grid } from "../../../services/visualLibraryService";
import { shadowStyled } from "../../../styles/shared-styles";
import { directions } from "../../../services/i18nService";

export const SearchPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
  height: 100%;
  &::after {
    ${props =>
      shadowStyled(
        "bottom",
        0,
        `${props.theme.baseLayoutPaddingBs * 2}%`,
        props.theme.backgroundRGB,
        1,
        props.theme.zIndex.base
      )};
    right: 0;
  }
`;

export const GridStyled = styled(Grid)`
  position: absolute;
  padding-top: ${props => props.theme.spacing.xsmall};
`;

export const BlockStyled = styled.div`
  width: ${props => (props.theme.locale.dir === directions.RIGHT_TO_LEFT ? "22.8vw" : "20.7vw")};
  & + & {
    width: 60%;
    margin: ${props => props.theme.baseLayoutPaddingBs}% ${props => props.theme.baseLayoutPaddingBs}% 0;
    ${props => (props.theme.locale.dir === directions.RIGHT_TO_LEFT ? "margin-right: 5rem" : "margin-right: 5rem")}
  }
  &:first-of-type {
    transform: ${props => props.isKeyboardInactive && !props.didYouMeanVisible && `translateY(-${props.position}px)`};
    transition: transform 0.5s ease-in-out;
  }
`;

export const LoadingStyled = styled(Loading)`
  margin-top: ${props => props.theme.spacing.medium};
`;

export const ContainerKeyboardStyled = styled.div`
  opacity: ${props => props.inactive && 0.4};
  margin-bottom: ${props => props.theme.spacing.small};
`;
